import React from 'react'; 

// create the global for your hook
const initialState = 0

const useGlobalHeader = React.createContext([{}, () => {}]); 

// export the provider to link in the application
//export const GlobalCounterProvider = Provider

// export the hook
export default useGlobalHeader